import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { HeroSection } from '@/components/sections/HeroSection';
import { ImageShowcaseSection } from '@/components/sections/ImageShowcaseSection';
import { WhyBESSSection } from '@/components/sections/WhyBESSSection';
import { CoreFunctionsSection } from '@/components/sections/CoreFunctionsSection';
import { EconomicsSection } from '@/components/sections/EconomicsSection';
import { ImplementationSection } from '@/components/sections/ImplementationSection';
import { SecuritySection } from '@/components/sections/SecuritySection';
import { CaseStudiesSection } from '@/components/sections/CaseStudiesSection';
import { SustainabilitySection } from '@/components/sections/SustainabilitySection';
import { FutureTrendsSection } from '@/components/sections/FutureTrendsSection';
import { ContactSection } from '@/components/sections/ContactSection';
import { Navigation } from '@/components/layout/Navigation';
import { Footer } from '@/components/layout/Footer';
import { ContactModal } from '@/components/ContactModal';
import { MobileFloatingCTA } from '@/components/MobileFloatingCTA';

export default function HomePage() {
  const [isContactOpen, setIsContactOpen] = useState(false);
  const openContact = () => setIsContactOpen(true);
  const closeContact = () => setIsContactOpen(false);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
      }
    }
  }, [location]);

  return (
    <div className="min-h-screen">
      <Navigation onContactClick={openContact} />
      <main>
        <HeroSection onContactClick={openContact} />
        <ImageShowcaseSection />
        <WhyBESSSection />
        <CoreFunctionsSection />
        <EconomicsSection />
        <ImplementationSection />
        <SecuritySection />
        <CaseStudiesSection />
        <SustainabilitySection />
        <FutureTrendsSection />
        <ContactSection onContactClick={openContact} />
      </main>
      <Footer />
      <ContactModal isOpen={isContactOpen} onClose={closeContact} />
      <MobileFloatingCTA onClick={openContact} />
    </div>
  );
}
